/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
  color?: string;
};

const PastVisitsRowIcon: FC<IProps> = ({ width = 20, height = 20, color = "#262626" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 20 20" fill="none">
    <path d="M13.3333 18.4053H15C15.442 18.4053 15.8659 18.2297 16.1785 17.9171C16.4911 17.6045 16.6667 17.1806 16.6667 16.7386V5.90525L12.5 1.73859H5C4.55797 1.73859 4.13405 1.91418 3.82149 2.22674C3.50893 2.5393 3.33333 2.96323 3.33333 3.40525V5.90525M11.6667 1.73859V5.07192C11.6667 5.51395 11.8423 5.93787 12.1548 6.25043C12.4674 6.56299 12.8913 6.73859 13.3333 6.73859H16.6667M7.91667 14.6553L6.66667 13.6136V11.7386M11.6667 13.4053C11.6667 16.1667 9.42809 18.4053 6.66667 18.4053C3.90524 18.4053 1.66667 16.1667 1.66667 13.4053C1.66667 10.6438 3.90524 8.40525 6.66667 8.40525C9.42809 8.40525 11.6667 10.6438 11.6667 13.4053Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default PastVisitsRowIcon;
